import type { RelatedFrame } from "@/hooks/useTaskRelatedFrames";
import { cn } from "@/utils/utils";

export type FrameKind = "this-task" | "labeled" | "other-task" | "context";

/**
 * What a frame in the scrubber is: this task's own frame (the one labeled
 * here), a frame a labeler already labeled in its own task, a frame another
 * task will label (it's pre-filled from this one's labels on submit), or a
 * frame no coverage task labels — context only.
 */
export const frameKind = (
  frame: RelatedFrame,
  isPrimary: boolean,
): FrameKind => {
  if (isPrimary) return "this-task";
  if (frame.annotations.some((a) => a.source === "HUMAN")) return "labeled";
  if (frame.task_id) return "other-task";
  return "context";
};

const CHIPS: Record<FrameKind, { label: string; className: string }> = {
  "this-task": { label: "This task", className: "bg-orange-500 text-white" },
  labeled: { label: "Labeled", className: "bg-green-600 text-white" },
  "other-task": { label: "Other task", className: "bg-blue-600 text-white" },
  context: { label: "Context only", className: "bg-gray-500 text-white" },
};

export const FrameKindChip = ({ kind }: { kind: FrameKind }) => (
  <span
    className={cn(
      "rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide",
      CHIPS[kind].className,
    )}
  >
    {CHIPS[kind].label}
  </span>
);
